"use client";
import { useEffect, useState } from "react";
import { Modal } from "@/utils/bootstrap";
import { safeHTML } from "@/utils/functions/safeHTML";
import { usePathname } from "next/navigation";
import { i18n } from "../../../../i18n-config";

interface Props {
  content: string;
}

const StartStoreMessageModal: React.FC<Props> = ({ content }) => {
  const [showModal, setShowModal] = useState(false);
  const pathname = usePathname();
  useEffect(() => {
    if (isHomePage(pathname)) setShowModal(true);
  }, []);
  if (!showModal || !isHomePage(pathname)) return null;
  return (
    <Modal
      centered
      show={showModal}
      dialogClassName="messagebox-dialog"
      size="lg"
      contentClassName="w-auto m-0"
      onHide={() => setShowModal(false)}
      style={{ overflowY: "auto", overflowX: "auto" }}
    >
      <Modal.Body>
        <div
          dangerouslySetInnerHTML={{
            __html: safeHTML(content),
          }}
        ></div>
      </Modal.Body>
    </Modal>
  );
};

export default StartStoreMessageModal;
const isHomePage = (url: string) => {
  const urlTerms = url.split("/");
  if (urlTerms.length === 2 && ["", ...i18n.locales].includes(urlTerms[1]))
    return true;
  return false;
};
